import React, { useState } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import BackButton from '../COMPONENTS/BackButton';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import { HIDDEN, SHOW, FADE, HIDE } from '../../HOME/const';
import { delay } from '../../HOME/utils';
import { NoGradientBackground } from '../COMPONENTS/Background';
import Toolbar from '../COMPONENTS/Toolbar';
import Scoreboard from '../COMPONENTS/Scoreboard';
import Board from '../COMPONENTS/Board';
import Options from '../COMPONENTS/Options';
import Leaderboard from '../COMPONENTS/Leaderboard';
import { requestResetStats, requestSurrender } from '../../HOME/REDUX/actions';

const GamePage = props => {
  const [options, setOptions] = useState(HIDDEN);

  const handleOptions = e => {
    props.requestResetStats(false);
    props.requestSurrender(false);

    if (options === SHOW) {
      hideOptions();
    } else if (options === HIDDEN) {
      setOptions(SHOW);
    }
  };

  const hideOptions = e => {
    if (options === SHOW) {
      setOptions(FADE);
      delay(() => setOptions(HIDDEN));
    }
  };

  const handleClick = e => {
    let id = e.target.id;

    if (!id) {
      id = e.target.parentElement.id;
    }

    if (id !== 'options-button' && !id.startsWith('volume-')) {
      hideOptions();
    }
  };

  return (
    <div className="page-root">
      <div className="re-page ta-game-page" style={{ backgroundImage: NoGradientBackground }} onClick={handleClick}>
        <Scoreboard />
        <div style={{ alignSelf: 'center', justifySelf: 'center' }}>
          <Board rows={3} cols={4} stackSize={props.size + 1} />
        </div>
        {props.showLeaders === HIDE ? null : <Leaderboard />}
      </div>
      <Options op={options} hideOptions={hideOptions} />
      <Toolbar onClickOptions={handleOptions} hideOptions={hideOptions} />
      {props.showLeaders === HIDE ? (
        <>
          <BackButton />
          <HomeButton color="black" />
        </>
      ) : null}
    </div>
  );
};

function mapStateToProps({ re, common }) {
  return { ...re, ...common };
}

export default connect(
  mapStateToProps,
  { requestResetStats, requestSurrender }
)(GamePage);
